(function($) {
  'use strict';

  Drupal.behaviors.adaptivePlaceholders = {
    attached: false,
    context: null,
    observer: null,
    classes: {
      labelMode: 'adpl__mode-label',
      placeholderMode: 'adpl__mode-placeholder',
      processedInput: 'adpl--processed'
    },

    attach: function(context) {
      if (this.attached) {
        return;
      }

      this.attached = true;

      this.context = context;

      this.setupObserver();

      this.observeTargets();
    },

    setupObserver: function() {
      var self = this;

      if (this.observer !== null) {
        return;
      }

      var handler = function(entries) {
        _.each(entries, function(entry) {
          if (!entry.isIntersecting) {
            return;
          }

          var target = entry.target;

          self.observer.unobserve(target);

          self.init(target);
        });
      };

      this.observer = new IntersectionObserver(handler, {
        root: null,
        rootMargin: '0px 0px 20% 0px',
        threshold: [0.1]
      });
    },

    observeTargets: function() {
      var self = this;

      var targets = $(
        '.adpl input[type="text"], \
        .adpl input[type="email"], \
        .adpl input[type="tel"], \
        .adpl input[type="number"], \
        .adpl input[type="password"], \
        .adpl textarea',
        this.context
      ).not('.no-adpl');

      targets.each(function(index, target) {
        if (self.observer) {
          self.observer.observe(target);
        }
      });
    },

    init: function(target) {
      var $input = $(target);

      if ($input.hasClass(this.classes.processedInput)) {
        return;
      }

      var $label = $input.siblings('label');
      var placeholder = $input.attr('placeholder') || $label.attr('placeholder');

      // input needs a placeholder
      if (!placeholder) {
        return true;
      }

      this.setLabel($input, $label, placeholder);
      this.setInput($input);

      // set states, bind events
      this.placeholderMode($input);
      this.bindEvents($input);
      this.toggleMode($input);

      // add CSS class for styling
      $input.addClass(this.classes.processedInput);
    },

    setLabel: function($input, $label, placeholder) {
      // ensure that label contains attributes required for display
      if (!$label[0].hasAttribute('placeholder')) {
        $label.attr('placeholder', placeholder);
      }

      // ensure that label contains an inner span.label-content wrapping the text
      if ($label.find('span.label-content').length < 1) {
        $label.wrapInner('<span class="label-content"></span>');
      }

      // position the label after the input, required for proper z-index
      $label.insertAfter($input);
    },

    setInput: function($input) {
      // google_autcomplete can't have its placeholder attribute removed without it reverting
      // to show the default, so we use an empty string instead of removing the attribute
      $input.attr('placeholder', '');
    },

    labelMode: function($input) {
      $input
        .addClass(this.classes.labelMode)
        .removeClass(this.classes.placeholderMode);
    },

    placeholderMode: function($input) {
      $input
        .removeClass(this.classes.labelMode)
        .addClass(this.classes.placeholderMode);
    },

    toggleMode: function($input) {
      if ($input.val() === '') {
        this.placeholderMode($input);
      } else {
        this.labelMode($input);
      }
    },

    bindEvents: function($input) {
      var self = this;

      // swap out placeholder/label classes on focus in or out
      $input.on('focusin', function() {
        self.labelMode($input);
      }).on('focusout', function() {
        self.toggleMode($input);
      }).on('change', function() {
        self.toggleMode($input);
      });
    }
  };
})(jQuery);
